module.exports = __webpack_public_path__ + "static/screenshot4-88a88413de79bf570d0b04e3874b957c.png";